let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aYD34")).then(() => parcelRequire('3Aus6'));